import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Checkout from "../pages/Checkout/Checkout";

const PublicRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/" element={<Navigate to="/checkout" replace />} />
    </Routes>
  );
};

export default PublicRoutes;